export function entries<V, T>(
  object: { [s: string]: T } | Map<string, V>
): [string, unknown][] | [string, V][] | [string, V][] {
  if (object instanceof Map && object.entries) return [...object.entries()];

  return [...Object.entries(object)];
}
